import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { GithubBranchIcon } from 'foundations-assets/icons/components/GithubBranchIcon';
export function getTemplateIcon(illustration) {
  switch (illustration) {
    case 'EMAIL':
      return EmailIcon;
    default:
      return GithubBranchIcon;
  }
}